import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "className", "underline", "use"],
  _excluded2 = ["as"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { forwardRef } from 'react';
import theme from '../theme.config';
import { isAnchor, isLink } from './utils';
import { clsx } from '../../utils';
import { color, spacing } from '../../themes/tokens';
function getWrappedElement(children) {
  return typeof children === 'string' ? React.createElement("span", {
    role: "link",
    tabIndex: 0
  }, children) : React.Children.only(children);
}
var focusStyles = {
  outlineOffset: '2px'
};
var underlineStyles = {
  textDecorationLine: 'underline',
  textDecorationThickness: '2px',
  textUnderlineOffset: spacing['spacing-1'].value
};
var styles = theme.css({
  fontFamily: '$defaultFont',
  variants: {
    use: {
      primary: {
        color: color['color-interactive-default'].value,
        cursor: 'pointer',
        textDecorationLine: 'none',
        '&:focus': focusStyles,
        '&:hover': {
          color: color['color-interactive-hovered'].value
        },
        '&:active, &:visited': {
          color: color['color-interactive-visited'].value
        },
        '&:hover, &:active, &:visited': underlineStyles
      },
      secondary: {
        color: color['color-text-subtle'].value,
        cursor: 'pointer',
        textDecorationLine: 'none',
        '&:focus': focusStyles,
        '&:hover': {
          color: color['color-text-default'].value
        },
        '&:active, &:visited': {
          color: color['color-interactive-visited'].value
        },
        '&:hover, &:active, &:visited': underlineStyles
      },
      contrast: {
        color: color['color-text-contrast'].value,
        cursor: 'pointer',
        textDecorationLine: 'none',
        '&:focus': focusStyles,
        '&:hover, &:active, &:visited': underlineStyles
      },
      reset: {
        color: 'inherit',
        textDecoration: 'none'
      }
    },
    underline: {
      "true": {
        textDecorationLine: 'underline',
        textUnderlineOffset: spacing['spacing-1'].value
      }
    }
  }
});
var EzLink = forwardRef(function (props, ref) {
  var _ref = props,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    underline = _ref.underline,
    _ref$use = _ref.use,
    use = _ref$use === void 0 ? 'primary' : _ref$use,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var content = children;
  if (isLink(passThroughProps)) {
    var options = passThroughProps;
    var type = options.href ? 'a' : as;
    content = React.createElement(type, options, children);
  }
  var el = getWrappedElement(content);
  return React.createElement(React.Fragment, null, React.cloneElement(el, _objectSpread({
    ref: el.ref || ref,
    className: clsx(styles({
      use: use,
      underline: underline
    }), className, el.props.className)
  }, passThroughProps)));
});
export var Link = forwardRef(function (props, ref) {
  if (isAnchor(props)) {
    return React.createElement("a", _extends({}, props, {
      ref: ref
    }), props.children);
  }
  var Component = props.as,
    rest = _objectWithoutProperties(props, _excluded2);
  var LinkComponent = Component;
  return React.createElement(LinkComponent, _extends({
    ref: ref
  }, rest));
});
EzLink.displayName = 'EzLink';
export default EzLink;